import { useCallback } from 'react';
import useAppshellCookies from 'AppShell/hooks/useAppshellCookies';
import { CookieConsentType } from 'AppShell/appshell_types/cookieConsentType';

const COOKIE_CONSENT_GROUP_KEY = 'OptanonConsent';
const STRICTLY_NECESSARY_COOKIE_GROUP_KEY = 'C0001';
const PERFORMANCE_COOKIE_GROUP_KEY = 'C0002';
const FUNCTIONAL_COOKIE_GROUP_KEY = 'C0003';
const TARGETING_COOKIE_GROUP_KEY = 'C0004';
const SOCIAL_MEDIA_COOKIE_GROUP_KEY = 'C0005';

const useCookieConsent = (): CookieConsentType => {
    const [consentGroup] = useAppshellCookies(COOKIE_CONSENT_GROUP_KEY);
    const [groupsCookie] = consentGroup
        ? consentGroup.split('&').filter((item: string) => item.includes('groups'))
        : [];
    const [, groupsCookieValue] = groupsCookie && groupsCookie.includes('=') ? groupsCookie.split('=') : '';

    const getCookieValue = useCallback(
        (key: string): boolean => {
            const keyWithColon = `${key}:`;
            if (!groupsCookieValue || !groupsCookieValue.includes(keyWithColon)) {
                return false;
            }

            const [targetCookie] = groupsCookieValue.split(',').filter((item: string) => item.includes(keyWithColon));
            if (!targetCookie || !targetCookie.includes(':')) {
                return false;
            }

            const [, cookieValue] = targetCookie.split(':');
            return cookieValue && cookieValue === '1';
        },
        [groupsCookieValue]
    );

    return {
        strictlyNecessaryCookies: getCookieValue(STRICTLY_NECESSARY_COOKIE_GROUP_KEY),
        performanceCookies: getCookieValue(PERFORMANCE_COOKIE_GROUP_KEY),
        functionalCookies: getCookieValue(FUNCTIONAL_COOKIE_GROUP_KEY),
        targetingCookies: getCookieValue(TARGETING_COOKIE_GROUP_KEY),
        socialMediaCookies: getCookieValue(SOCIAL_MEDIA_COOKIE_GROUP_KEY),
    };
};

export default useCookieConsent;
